module.exports = __webpack_public_path__ + "static/media/logo_border_star_00028.93d89c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/border-star/logo_border_star_00028.png
// module id = 441
// module chunks = 0